import { RawHtml } from '@hyphengroup/cms-components/components/RawHtml/RawHtml';
import { TheWrapper } from '@hyphengroup/cms-components/components/TheWrapper';
import { ComponentWhiteTextBlock } from '$/(cms)/_modules/cmsService/types';

export const TheWhiteBoard: React.FC<ComponentWhiteTextBlock> = ({
  id,
  content,
}) => {
  return (
    <TheWrapper id={id} type="full">
      <div id={id} className="p-3 bg-white xl:p-3">
        <RawHtml className="prose prose-xl max-w-full" content={content} />
      </div>
    </TheWrapper>
  );
};
